import { Stack } from "@mui/material";
import { DropdownSingleSelect } from "components/DropdownSingleSelect";
import { useTranslation } from "react-i18next";

import type { EnergyAnalysisYearRange } from "../model/types";

import { EnergyAnalysisSettingsGroup } from "./EnergyAnalysisSettingsGroup";

type EnergyAnalysisYearRangeSelectProps = {
  disabled?: boolean;
  onChange: (yearRange: EnergyAnalysisYearRange) => void;
  yearRange?: EnergyAnalysisYearRange;
  years: number[];
};

const isYear = (value: unknown): value is number => typeof value === "number" && Number.isFinite(value);

export const EnergyAnalysisYearRangeSelect = ({
  disabled,
  onChange,
  yearRange,
  years,
}: EnergyAnalysisYearRangeSelectProps) => {
  const { t } = useTranslation();
  const fromYear = yearRange?.[0];
  const toYear = yearRange?.[1];
  const fromYears = years.filter((year) => toYear === undefined || year <= toYear);
  const toYears = years.filter((year) => fromYear === undefined || year >= fromYear);
  return (
    <EnergyAnalysisSettingsGroup className="flex-row" iconName="Calendar" label={t("BuildingProfile.energyAnalysis.settings.yearRange") as string}>
      <Stack className="items-center gap-2">
        <DropdownSingleSelect
          className="w-28"
          clearable={false}
          disabled={disabled || years.length === 0}
          displayOptions={fromYears.map((year) => `${year}`)}
          height="3.2rem"
          hideLabel
          options={fromYears}
          selectedValue={fromYear}
          setSelectedValue={(value) => {
            if (isYear(value) && toYear !== undefined) onChange([value, toYear]);
          }}
        />
        <span className="text-lds-foreground-muted font-ds-body-regular-sm">
          {t("BuildingProfile.energyAnalysis.settings.yearTo")}
        </span>
        <DropdownSingleSelect
          className="w-28"
          clearable={false}
          disabled={disabled || years.length === 0}
          displayOptions={toYears.map((year) => `${year}`)}
          height="3.2rem"
          hideLabel
          options={toYears}
          selectedValue={toYear}
          setSelectedValue={(value) => {
            if (isYear(value) && fromYear !== undefined) onChange([fromYear, value]);
          }}
        />
      </Stack>
    </EnergyAnalysisSettingsGroup>
  );
};
